export default __webpack_public_path__ + "static/media/logo.cbc21180.svg";